import React, { Component } from "react";
import AppointmentDetail from "./appointmentDetailsTile";
import NoAppointmentsTile from "./NoAppointmentsTile";
import ErrorLoadingTile from '../../common/errorLoadingTile';

import DashboardTileLoader from '../DashboardTileLoader';
import { connect } from "react-redux";
import * as Tools from "../../../helpers/Tools";
import { logUI } from "../../../api/andyliticsApi";
import * as d from "../../../reducers/domainReducer";

class AppointmentTile extends Component {

    constructor(params) {
        super(params);
        this.state = {
            apptDetails: []
        }
    }

    componentDidMount() {
        logUI("MBHWeb.UI.AppointmentTile.ComponentDidMount", new Date(), Tools.getURLPath());
    }

    getCurrentAppointments(appointmentDetails) {
        const { isShowAllUsers } = this.props;
        let appointments = [];
        if (appointmentDetails) {
            appointments = isShowAllUsers ? appointmentDetails : appointmentDetails.length === 1 ? appointmentDetails : this.getCurrentUserAppts(appointmentDetails)
        }
        return appointments;
    }

    getCurrentUserAppts(appointmentDetails) {
        const { currentUser } = this.props;
        let appts = [];
        if (currentUser && appointmentDetails) {
            for (let i = 0; i < appointmentDetails.length; i++) {
                if (appointmentDetails[i] && appointmentDetails[i].patientExternalId &&
                                                    appointmentDetails[i].patientExternalId === currentUser.externalId) {
                    appts.push(appointmentDetails[i]);
                }
            }
        }
        return appts;
    }


    render() {
        const { dashboardServiceError, hasMyChart, bffDashboardWaiting, waitingOnVideoVisitLink, appointments, isMobile, roles, currentUser, isMyChartInActive, epicEHRDown, serverData, isProxyUser } = this.props;
        const isPOC = roles ? roles.toLowerCase().indexOf("video_poc") >= 0 : false;
        const ambulatoryVideoEnabled = serverData && serverData.ambulatoryVideoVisitEnabled;
        const showTestVideoLink = ambulatoryVideoEnabled && hasMyChart && isPOC && !isProxyUser;

        const appointmentDetails = this.getCurrentAppointments(appointments);

        const hasAppointment = appointmentDetails && appointmentDetails.csnIdOfAppointment !== null;

        //Need to wait for proxy information to load for first time login, due to filter appt from BFF call.
        let showSpinnerToSyncProxy = false;//!hasAppointment && !proxyFailure && hasMyChart && proxyListLoading ? true : false;
        const apptTileName = "Next Appointment";


        //debugger;
        return (
            !hasMyChart || isMyChartInActive || epicEHRDown || (bffDashboardWaiting === false && !appointmentDetails && !showSpinnerToSyncProxy)
                ? <NoAppointmentsTile isMobile={isMobile} disabled={isMyChartInActive || epicEHRDown} />
                : ((!appointmentDetails && !dashboardServiceError) || showSpinnerToSyncProxy || waitingOnVideoVisitLink)
                    ? <DashboardTileLoader />
                    : <React.Fragment>
                        {(!dashboardServiceError && hasAppointment && appointmentDetails && appointmentDetails.length > 0)
                            ? appointmentDetails?.map((appointmentDetails, index) =>
                                <AppointmentDetail
                                    key={'appointmentDetails_' + index}
                                    appointmentDetails={appointmentDetails}
                                    isMobile={isMobile}
                                    index={index}
                                />
                            )
                            : dashboardServiceError
                                ? <ErrorLoadingTile error={dashboardServiceError} />
                                : <NoAppointmentsTile isMobile={isMobile} />
                        }
                    </React.Fragment>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        isLoggedIn: state.domain.li,
        hasMyChart: state.domain.hm,
        roles: state.sso.userDetails ? state.sso.userDetails.Roles : "",
        currentUser: d.hydrateProxyUser(state.domain.cu),
        proxyFailure: state.memberships.proxyListFailure,
        proxyListLoading: state.memberships.proxyListLoading,
        dashboardServiceError: state.dashboard.bffDashboardData && state.dashboard.bffDashboardData.error,
        bffDashboardWaiting: state.dashboard.bffDashboardData && state.dashboard.bffDashboardData.isWaiting,
        waitingOnVideoVisitLink: state.dashboard?.waitingOnVideoVisitLink,
        isMyChartInActive: state.dashboard.isMyChartInActive,
        epicEHRDown: state.common.epicEHRDown,
        serverData: state.session.serverData,
        isProxyUser: state.domain.ip,
        isShowAllUsers: state.dashboard.isShowAllUsers
    };
};

export default connect(mapStateToProps, null)(AppointmentTile);


